$(function(){
  var urlParams = new URLSearchParams(window.location.search);
  var showReleaseJobParamInit = urlParams.get('showReleaseJob');
  var sortParamInit = urlParams.get('sort');
  var perPageInit = urlParams.get('per_page');
  var isCheckedTokyo = $("#job_search_form_area_8").prop('checked')

  $('#show_release_job').prop('checked', showReleaseJobParamInit === 'true');

  const listModalRegionOption = document.querySelectorAll("#modal_search_with_area .modal-body")
  listModalRegionOption.forEach(element => {
    const regionId = $(element).data('region-content')
    const checkAllEl = $(`input[data-region-title="${regionId}"]`)
    let totalOption = $(element).find(".area_options").children().length
    const totalOptionSelected =  $(element).find('input[type="checkbox"]:checked')

    if (regionId === 3) {
      totalOption += 10;
    }
    if (totalOption === totalOptionSelected.length) {
      checkAllEl.prop('checked', true)
    } else {
      checkAllEl.prop('checked', false)
    }
  });

  if (isCheckedTokyo) {
    const tokyoWard = $("input#tokyo_area_job").prop('checked')
    const childOptions = document.querySelectorAll("#tokyo_job_options input");
    childOptions.forEach(function(childOption) {
      childOption.checked = tokyoWard;
    });
  }

  if (sortParamInit) {
    $('.job-list_pagination_select #sort_select').val(sortParamInit);
  }

  if (perPageInit) {
    $('select#per_page').val(perPageInit);
  }

  var listAreaSearch = document.querySelectorAll("#modal_search_with_area .search_area_parent input")
  listAreaSearch.forEach(element => {
    element.addEventListener('change', function() {
      const dataRegion = $(this).data('region-title')
      var childOptions = document.querySelectorAll(`[data-region-content="${dataRegion}"] input`);
      var isParentSelected = element.checked;
      childOptions.forEach(function(childOption) {
        childOption.checked = isParentSelected;
      });
    });
  });

  $(document).on('click', 'input#tokyo_area_job', function(e){
    var tokyoWard = $("input#tokyo_area_job").prop('checked')
    var childOptions = document.querySelectorAll("#tokyo_job_options input");
    childOptions.forEach(function(childOption) {
      childOption.checked = tokyoWard;
    });
  })

  $('#modal_search_with_price input[type="checkbox"]').change(function() {
    $('#modal_search_with_price input[type="checkbox"]').not(this).prop('checked', false);
  });

  const workStyleSelectedForm = $('#workStyle_selection input[type="checkbox"]:checked').length;
  if (workStyleSelectedForm === 5) {
    $('input.work_style_full_remote').prop('checked', true);
  } else {
    $('input.work_style_full_remote').prop('checked', false);
  }

  $('input.work_style_full_remote').change(function() {
    if ($(this).prop('checked')) {
      $('input.work_style_full-remote').prop('checked', true);
      $('.work_style_full-remote-on-sight-only-first-day').prop('checked', true);
      $('.work_style_full-remote-on-sight-only-in-emergencies').prop('checked', true);
      $('.work_style_full-remote-on-sight-during-onboarding').prop('checked', true);
      $('.work_style_full-remote-switching-to-on-sight-possibly').prop('checked', true);
    } else {
      $('input.work_style_full-remote').prop('checked', false);
      $('.work_style_full-remote-on-sight-only-first-day').prop('checked', false);
      $('.work_style_full-remote-on-sight-only-in-emergencies').prop('checked', false);
      $('.work_style_full-remote-on-sight-during-onboarding').prop('checked', false);
      $('.work_style_full-remote-switching-to-on-sight-possibly').prop('checked', false);
    }
  });
    $('input.work_style_full-remote, input.work_style_full-remote-on-sight-only-first-day, input.work_style_full-remote-on-sight-only-in-emergencies').change(function() {
      const workStyleSelected = $('#workStyle_selection input[type="checkbox"]:checked').length;
      if ($(this).prop('checked')  && workStyleSelected === 5) {
        $('input.work_style_full_remote').prop('checked', true);
      } else {
        $('input.work_style_full_remote').prop('checked', false);
      }
    });
    $('input.work_style_full-remote-on-sight-during-onboarding, input.work_style_full-remote-switching-to-on-sight-possibly').change(function() {
      const workStyleSelected = $('#workStyle_selection input[type="checkbox"]:checked').length;
      if ($(this).prop('checked')  && workStyleSelected === 5) {
        $('input.work_style_full_remote').prop('checked', true);
      } else {
        $('input.work_style_full_remote').prop('checked', false);
      }
    });

    $('input.common_occupancy_rate_100').change(function() {
      if ($(this).prop('checked')) {
        $('input.occupancy_rate_100').prop('checked', true);
      } else {
        $('input.occupancy_rate_100').prop('checked', false);
      }
    });

    $('input.occupancy_rate_100').change(function() {
      if ($(this).prop('checked')) {
        $('input.common_occupancy_rate_100').prop('checked', true);
      } else {
        $('input.common_occupancy_rate_100').prop('checked', false);
      }
    });

    $('input.area_id_8').change(function() {
      $('input#tokyo_area_job').trigger('click')
    });

    $('.search_form input[type="checkbox"]').change(function() {
      performSearch();
    });

    $('.js-modal-search-pc input[type="checkbox"]').change(function() {
      handleCheckAll(this)
      performSearch();
      handleCountModalSearch()
    });
    handleCountModalSearch()

    $('.js-modal-search-sp input[type="checkbox"]').change(function() {
      handleCheckAll(this)
      performSearch();
      handleCountModalSearch()
    });

    $(document).on('click', '.reset_data_search_sp, .header_reset_btn', function(e) {
      $(".search-modal-jobs_sp").find('input[type="checkbox"]').prop("checked", false);
      performSearch();
      handleCountModalSearch()
    })

    let timeOutSearch;

    $("#job_search_form_keyword").keyup(function(){
        if ($(this).val().length > 0) {
          $(".icon_clear").removeClass('d-none');
        } else {
          $(".icon_clear").addClass('d-none');
        }
        clearTimeout(timeOutSearch)
        timeOutSearch = setTimeout(function(){ performSearch()}, 1500)
    })

    function handleCheckAll(target) {
      const searchAreaModal = $(target).closest('#modal_search_job_area')
      if (!searchAreaModal.length)  return;

      const listOption = $(target).closest(".area_options")
      const regionID = $(target).closest('.modal-body').data("region-content")
      const tokyoJobOption = $("#tokyo_job_options").children().length;
      const tokyoWardSelected = $("#tokyo_job_options").find('input[type="checkbox"]:checked')
      const checkAllEl = $(`input[data-region-title="${regionID}"]`)

      if (tokyoJobOption === tokyoWardSelected.length) {
        $("#tokyo_area_job").prop('checked', true)
        $("#job_search_form_area_8").prop('checked', true)
      } else {
        $("#tokyo_area_job").prop('checked', false)
        $("#job_search_form_area_8").prop('checked', false)
        checkAllEl.prop('checked', false)
      }
      let totalOption = listOption.children().length;
      const totalOptionSelected = listOption.find('input[type="checkbox"]:checked')

      if (regionID === 3) {
        totalOption += tokyoWardSelected.length;
      }
      if (totalOption === totalOptionSelected.length) {
        checkAllEl.prop('checked', true)
      } else {
        checkAllEl.prop('checked', false)
      }
    }

    function handleCountModalSearch() {
      let listModalSearchPC = ['.js-modal-search-occupation-pc', '.js-modal-search-skill-pc',
        '.js-modal-search-area-pc', '.js-modal-search-salary-pc']
      listModalSearchPC.forEach(element => {
        let count = $(element).find("input[type=checkbox]:checked").length
        if (count < 10 ) {
          count = '0' + count
        }
        $(element + '-count').text(count);
      })

      let listModalSearchSP = ['.js-modal-search-contract-type-sp', '.js-modal-search-work-style-sp',
        '.js-modal-search-occupation-sp', '.js-modal-search-skill-sp', '.js-modal-search-salary-sp',
        '.js-modal-search-occupancy-sp', '.js-modal-search-industry-sp', '.js-modal-search-area-sp',
        '.js-modal-search-listed-sp']
      listModalSearchSP.forEach(element => {
        let count = $(element).find("input[type=checkbox]:checked").length
        if (count === 0) {
          count = ""
        } else {
          count = "+" + count
        }
        $(element + '-count').text(count);
      })

      let listModalChildPC = ['.js-search-child-occupation-creator', '.js-search-child-occupation-engineer',
        '.js-search-child-skill-language', '.js-search-child-skill-database', '.js-search-child-skill-framework',
        '.js-search-child-skill-infra', '.js-search-child-skill-tool', '.js-search-child-skill-other']
      listModalChildPC.forEach(element => {
        let count = $(element).find("input[type=checkbox]:checked").length
        if (count === 0) {
          count = ""
        } else {
          count = " (" + count + ")"
        }
        $(element + '-count').text(count);
      })
      listModalChildPC.forEach(element => {
        let count = $(element + '-sp').find("input[type=checkbox]:checked").length
        if (count === 0) {
          count = ""
        } else {
          count = " (" + count + ")"
        }
        $(element + '-sp-count').text(count);
      })
    }

    function performSearch() {
      const formData = $(".new_job_search_form").serializeArray();
      const showReleaseJob = $("#show_release_job").prop('checked')
      const sortKey = $(".job-list_pagination_select #sort_select").val();
      formData.push({name: "job_search_form[showReleaseJob]", value: showReleaseJob});
      formData.push({name: "job_search_form[sort]", value: sortKey});

      $.ajax({
        url: '/jobs/count',
        type: 'GET',
        data: formData,
        dataType: 'json'
      }).done(function (data) {
        const { job_count } = data;
        $("#job_count").html(job_count?.toLocaleString())
        $("#job_count_modal").html(job_count?.toLocaleString())
        $("#job_count_modal_skill").html(job_count?.toLocaleString())
        $("#job_count_modal_price").html(job_count?.toLocaleString())
        $("#job_count_modal_area").html(job_count?.toLocaleString())
      });
    }

    function getSearchConditions() {
      let inputs = $(".new_job_search_form").find('input[type="checkbox"]:checked');
      let data = {};
      $.each(inputs, function (_, input) {
        if (data[input.dataset.name]) {
          if (!data[input.dataset.name].includes(input.value)) {
            data[input.dataset.name] += "," + input.value;
          }
        } else {
          data[input.dataset.name] = input.value;
        }
      });
      if ($('#job_search_form_keyword').val() != "") {
        data['keyword'] = $('#job_search_form_keyword').val()
      }
      if ($('#show_release_job').is(":checked")) {
        data['showReleaseJob'] = true
      }
      if ($('#sort_select').val() != 'new') {
        data['sort'] = $('#sort_select').val()
      }
      if ($('#per_page').val() != 30) {
        data['per_page'] = $('#per_page').val()
      }
      return data;
    }

    function searchUrl() {
      let data = getSearchConditions();
      const canonicalUrl = document.querySelector('link[rel="canonical"]')?.href ?? '';
      if (canonicalUrl !== '') {
        const q = (new URLSearchParams(data)).toString()

        if (canonicalUrl.includes('?')) {
          const a = new URLSearchParams(window.location.search)
          const b = new URLSearchParams(data)
          const merged = new URLSearchParams({
            ...Object.fromEntries(a),
            ...Object.fromEntries(b)
          })

          return decodeURIComponent(canonicalUrl.substring(0, canonicalUrl.indexOf('?')) + '?' + merged.toString());
        } else {
          return decodeURIComponent(canonicalUrl + '?' + q);
        }
      } else {
        return decodeURIComponent(Routes.jobs_path(data));
      }
    }

    $(document).on('click', '.search_form_result_btn, .search_form_result_btn_price, .search_form_result_btn_occupation, .search_form_result_btn_skill, .search_form_result_btn_area', function(){
      window.location.href = searchUrl();
    });

    $(document).on('click', '#show_release_job', function(e) {
      window.location.href = searchUrl();
    });

    $('.job-list_pagination_select #sort_select').on('change', function() {
      window.location.href = searchUrl();
    });

    $('select#per_page').on('change', function() {
      window.location.href = searchUrl();
    });

    $(document).on('click', '.reset_form_modal', function(e) {
      $(".search-modal-jobs").find('input[type="checkbox"]').prop("checked", false);
      performSearch();
      handleCountModalSearch();
    })

    $(document).on('click', ".js-submit-favorite-job", function(e) {
      $(this).prop("disabled", true);
      const jobTarget = $(this).data('job_id');
      let type = $(this).hasClass('favorite') ? 'un-favorite' : 'favorite'
      saveFavoriteJob(jobTarget, $(this), type);
    });

    $(document).on('click', '.close-job_favorite_alert', function(e){
      $(".job_favorite_alert").toggleClass('d-none')
    });

  function saveFavoriteJob(job_id, button, type = 'favorite') {
    let url = type === 'favorite' ? Routes.create_favorite_jobs_path() : Routes.destroy_favorite_jobs_path()
    return $.ajax({
      type: "POST",
      url: url,
      data: {
        authenticity_token: $("meta[name=csrf-token]").prop("content"),
        job_id: job_id,
      }
    }).done(function (response) {
      if (response.save) {
        commonFunctions.enableButtonWhenLoadingDone(button)
        $(".js-count-favorite-job").text(response.count)
        if (type === 'favorite') {
          $(button).addClass('favorite')
        } else {
          $(button).removeClass('favorite')
        }
      } else {
        $("#job_favorite_alert").removeClass('d-none')
        window.scrollTo({top: 0, behavior: 'smooth'});
      }
      $(button).prop("disabled", false);
    }).fail(function (errorThrown) {
    });
  }

  $(document).on('click', '.icon_clear', function(e){
    $(".input_search").val('');
  });

  $(document).on('click', '.js-icon-show-hide', function(e){
    $(this).find('.icon-hide').toggleClass('d-none');
    $(this).find('.icon-show').toggleClass('d-none');
    console.log($(this).parents('.js-area-show-hide').find('.js-content-show-hide'))
    $(this).parents('.js-area-show-hide').find('.js-content-show-hide').toggleClass('d-none');
  });

    $(".input_search").keypress(function(event) {
      if (event.which === 13) {
        var value_keyword = $(this).val();
        if (value_keyword.length > 0) {
          window.location.href = Routes.jobs_path({
            keyword: value_keyword,
          });
        } else {
          window.location.href = Routes.jobs_path();
        }
      }
    });

    const formSearchSp = document.getElementById('js-job-search-form-sp');
    if (formSearchSp) {
      formSearchSp.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          $(".search_form_result_btn").trigger('click')
        }
      });
    } else {
      $('#job_search_form_keyword').on('keydown', function(e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          window.location.href = searchUrl();
        }
      });
    }
    var modalList = document.querySelectorAll("#js-job-search-form .modal.modal-search")
    let opsetTopModal = $(window).height() - sb_sticky.innerHeight() - 30;
    modalList.forEach(function(modal) {
      modal.addEventListener('show.bs.modal', function (event) {
        if ($(".jobs_container_hasFilter").hasClass("fixed")) {
          $(".jobs_container_hasFilter").removeClass("fixed");
          $(".jobs_container_hasFilter").addClass("absolute");
          const positionTop = $(window).scrollTop();
          $(".jobs_container_hasFilter").css({
            top: positionTop + opsetTopModal,
          });
        }
      })

      modal.addEventListener('hide.bs.modal', function (event) {
        if ($(".jobs_container_hasFilter").hasClass("absolute")) {
          $(".jobs_container_hasFilter").removeClass("absolute");
          $(".jobs_container_hasFilter").addClass("fixed");
          sidebarSticky();
        }
      })
    })
})


var sb_sticky = $('.jobs_container_hasFilter');
if(sb_sticky.length > 0){
  var w = 0, h = sb_sticky.innerHeight(), top = 0, bot = 0;
  var height_content = $('.jobs_container_right .jobs_card_list').innerHeight();
  top = sb_sticky.offset().top;
  var old_scroll = 0, current_scroll=$(window).scrollTop(), sb_top = 100;
  var sidebarSticky = function(){
    if($(window).width() > 1119){
      w = sb_sticky.parent().width();
      bot = sb_sticky.parent().offset().top + sb_sticky.parent().innerHeight();
      height_content = $('.jobs_container_right .jobs_card_list').innerHeight();
      h = sb_sticky.innerHeight();
      if ( height_content > h) {
        if($(window).scrollTop() > top - 100){
          sb_sticky.addClass('fixed').css({
            top: 100,
            width: w,
          });

          if(h + 100 >= $(window).height()){
            var range = old_scroll - $(window).scrollTop();
            sb_top = sb_top + range;
            if(old_scroll < $(window).scrollTop()){
              sb_top = $(window).height() - h - 30< sb_top ? sb_top : $(window).height() - h - 30;
            }
            else{
              sb_top = 100 > sb_top ? sb_top : 100;
            }
            sb_sticky.addClass('fixed').css({
              top: sb_top,
            });
          }

          if($(window).scrollTop() + h + 100 > bot ){
            sb_sticky.addClass('fixed').css({
              top: bot - $(window).scrollTop() - h,
            });
          }
        }
        else{
          sb_sticky.removeClass('fixed').css({
            top: '',
            width: '',
          });
        }
      }
      else {
        sb_sticky.removeClass('fixed').css({
          top: '',
          width: '',
        });
      }
    }
    old_scroll = $(window).scrollTop();
  }
  $(window).on('scroll', commonFunctions.rafThrottle(function(event) {
    sidebarSticky();
  }))
}

$(function(){
  const $body = $("body")

  $body.on("click", '.job_card_view_more', function(e) {
    e.preventDefault();
    $(this).siblings(".job_card_detail").addClass("active");
    $(this).addClass('d-none');
    $(this).siblings(".job_card_hide").addClass('d-block')
  });
  $body.on("click", '.job_card_hide', function(e) {
    e.preventDefault();
    $(this).siblings(".job_card_detail").removeClass("active");
    $(this).removeClass('d-block').addClass('d-none');
    $(this).siblings(".job_card_view_more").removeClass('d-none').addClass('d-block')
  });
  $(document).on('click','.js-search_condition_action', function(e){
    $(".open_modal_search_job_sp:first").trigger('click');
  });
});
